import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractDynamicComponent } from '@components/abstracts';
import { PushTutos } from '@components/push-tutos/models';
import { OptionCardComponent } from '@shared/components/option-card';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';

@Component({
  selector: 'app-push-tutos',
  imports: [TitleComponent, RouterLink, OptionCardComponent, SvgComponent],
  templateUrl: './push-tutos.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PushTutosComponent extends AbstractDynamicComponent<PushTutos> {}
